export default __webpack_public_path__ + "static/media/botox.dac3c02a.svg";